import { Avatar, darken, Tooltip, Typography } from "@mui/material"
import React from "react"

interface IProps {
  content?: string | number
  icon?: React.JSX.Element
  color?: string
  backgroundColor: string
  cursor?: string
  tooltipText?: string
  disabled?: boolean

  onClick?(event: React.MouseEvent): void
}

export function SquareBadge({
  content,
  icon,
  color,
  backgroundColor,
  onClick,
  cursor = "default",
  tooltipText,
  disabled = false,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <Tooltip title={tooltipText} arrow placement="bottom">
      <Avatar
        sx={{
          width: 26,
          height: 26,
          bgcolor: backgroundColor,
          cursor,
          borderRadius: "5px",
          p: 2,
          "&:hover": {
            backgroundColor: darken(backgroundColor, 0.1),
          },
        }}
        onClick={!disabled ? onClick : undefined}>
        {icon || <Typography sx={{ color, fontWeight: 600 }}>{content}</Typography>}
      </Avatar>
    </Tooltip>
  )
}
